// Mapping of print methods to maximum allowed logo area (in cm²)
export const printMethodAreas = {
    TF1: 200,
    DTF1: 100,
    DTF2: 200,
    DTF3: 400,
    DTF4: 700,
    D: 15,
    L2A: 20,
    L2B: 60,
    L3A: 20,
    L3B: 60,
    L4A: 20,
    L4B: 60,
    FC1: 10,
    FC2: 30,
    FC3: 100,
    H1: 50,
    H2: 100,
};

export function getPrintMethodArea(printMethod) {
    if (!printMethod) {
        return null;
    }
    return printMethodAreas[printMethod.toUpperCase()] ?? null;
}
